export default {
  namespaced: true,
  state: {
    user: ""
  },
  // -----------------------------------------------------------------
  getters: {
    getUser: state => {
      return state.user;
    }
  },
  // -----------------------------------------------------------------
  mutations: {
    setUser(state, data) {
      state.user = data.user;
    },
    resetUser(state) {
      state.user = null;
    }
  },
  // -----------------------------------------------------------------
  actions: {
    setUser: (context, data) => {
      context.commit("setUser", data);
    },
    resetUser: context => {
      context.commit("resetUser");
    }
  }
};
